// Nombre en castellano de un color a partir de su hex, para los botones de
// color que no tienen texto (aria-label). Es una aproximacion por tono: basta
// para que quien usa lector de pantalla distinga una muestra de otra.
export function colorNombre(hex) {
  const m = /^#?([0-9a-f]{6})$/i.exec(String(hex || "").trim());
  if (!m) return String(hex || "");
  const n = parseInt(m[1], 16);
  const r = (n >> 16) / 255, g = ((n >> 8) & 255) / 255, b = (n & 255) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min;
  const l = (max + min) / 2;
  const s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
  if (s < 0.12) return l < 0.3 ? "negro" : l > 0.8 ? "blanco" : "gris";
  let h = d === 0 ? 0 : max === r ? ((g - b) / d) % 6 : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
  h = (h * 60 + 360) % 360;
  const claro = l > 0.62 ? " claro" : l < 0.3 ? " oscuro" : "";
  const base = h < 12 || h >= 346 ? "rojo" : h < 40 ? (l < 0.4 ? "marrón" : "naranja")
    : h < 65 ? (l < 0.4 ? "marrón" : "amarillo") : h < 165 ? "verde" : h < 200 ? "turquesa"
    : h < 255 ? "azul" : h < 290 ? "violeta" : "rosa";
  return base + claro;
}

// Los nombres de icono vienen de la libreria de iconos (people-fill...): se
// leen sin guiones ni el sufijo -fill.
export function iconoNombre(ic) {
  return String(ic || "").replace(/-fill$/, "").replace(/-/g, " ");
}
